const fontSize = {
  extraSmall: '0.75rem', // 12px
  small: '0.875rem', // 14px
  regular: '0.9375rem', // 15px
  smallHeader: '1.0625rem', // 17px
  header: '1.5rem', // 24px
  key: '2.625rem', // 42px
};

export default fontSize;
